import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "inner"
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["href", "aria-label"]

import { Skeletor } from 'vue-skeletor';
import { Icon } from '../../Atoms';
import 'vue-skeletor/dist/vue-skeletor.css';


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoCard',
  props: {
    iconName: {},
    text: {},
    backgroundColor: {},
    borderColor: {},
    lg: { type: Boolean },
    isLoading: { type: Boolean },
    embeddedLink: {},
    embeddedLinkText: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["infoCard", { lg: _ctx.lg, loading: _ctx.isLoading }]),
    style: _normalizeStyle({
      backgroundColor: _ctx.isLoading ? 'transparent' : _ctx.backgroundColor,
      borderColor: _ctx.borderColor ? _ctx.borderColor : 'transparent',
    })
  }, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.iconName)
            ? (_openBlock(), _createBlock(_unref(Icon), {
                key: 0,
                "icon-name": _ctx.iconName
              }, null, 8, ["icon-name"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: "text",
            role: "heading",
            "aria-level": "3",
            "aria-label": _ctx.embeddedLinkText ? `${_ctx.text}, link: ${_ctx.embeddedLinkText}` : _ctx.text
          }, [
            _createTextVNode(_toDisplayString(_ctx.text) + " ", 1),
            (_ctx.embeddedLink && _ctx.embeddedLinkText)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "embeddedLink",
                  href: _ctx.embeddedLink,
                  target: "_blank",
                  "aria-label": _ctx.text
                }, _toDisplayString(_ctx.embeddedLinkText), 9, _hoisted_3))
              : _createCommentVNode("", true)
          ], 8, _hoisted_2)
        ]))
      : (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_unref(Skeletor), { key: 1 }))
        : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}
}

})